/* Error.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syaz1rpy%7Bcolor%3Avar(--ds-text-subtlest%2C%236b6e76)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19pku2gc%7Bmargin-top%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19bv1ejb%7Bpadding-left%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._n3td1ejb%7Bpadding-bottom%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._u5f31ejb%7Bpadding-right%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._ca0q1ejb%7Bpadding-top%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._y3gn1h6o%7Btext-align%3Acenter%7D");
import React from 'react';
import { cx } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';
const styles = {
  errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
  errorTitle: "_19pku2gc",
  teamErrorText: "_syaz1rpy _19pku2gc"
};
export const ErrorWrapper = (props: {
  children: React.ReactNode;
  testId?: string;
}): React.JSX.Element => <Box xcss={cx(styles.errorWrapper)} {...props} />;
export const ErrorTitle = (props: {
  children: React.ReactNode;
}): React.JSX.Element => <Box xcss={styles.errorTitle}>
		<Text color="color.text">{props.children}</Text>
	</Box>;
export const TeamErrorText = (props: {
  children: React.ReactNode;
}): React.JSX.Element => <Box xcss={cx(styles.teamErrorText)}>{props.children}</Box>;